import { queryUserWalletInfo } from "@/api/dex"

const useWalletStore = defineStore('wallet', () => {

  /**
   * 钱包信息
   */
  const walletInfo = ref<any>(null)

  /**
   * 资产列表
   */
  const userAssets = computed(() => {
    return walletInfo.value?.assets ?? []
  })

  /**
   * 资产Map
   */
  const assetsMap = computed(() => {
    if (!walletInfo.value?.assets) return {}
    const result: any = {}
    walletInfo.value?.assets.forEach((item: any) => {
      result[item.assetSymbol] = item
    })
    return result
  })

  /**
   * 资产Map
   */
  const addressAssetsMap = computed(() => {
    if (!walletInfo.value?.assets) return {}
    const result: any = {}
    walletInfo.value?.assets.forEach((item: any) => {
      result[item.tokenAddress] = item
    })
    return result
  })

  /**
   * 查询钱包信息
   */
  const queryWalletInfo = async () => {
    try {
      const { data } = await queryUserWalletInfo()
      walletInfo.value = data[0]
    } catch (e) {
      console.log('e', e)
    }
  }
  return { walletInfo, userAssets, assetsMap, addressAssetsMap, queryWalletInfo }
})

export default useWalletStore
